var ckeditorConfig = {
    extraPlugins : 'abbr,autocorrect,autolink,lineheight,oxzion,preview,quicktable,sourcedialog,tableresize,texttransform,uploadimage',
    selfHostedPlugins: 'abbr,autocorrect,lineheight,quicktable,texttransform',
    height: 400,
    width: '100%',
    //IMPORTANT: Need this setting to retain HTML tags as we want them. Without this setting, 
    //CKEDITOR removes tags like span and flattens HTML structure.
    allowedContent: true,
    //extraAllowedContent:'span(*)',
    oxzion: {
        dimensions: {
            begin: {
                width: 300,
                height: 400
            },
            min: {
                width: 100,
                height: 100
            },
            max: {
                width: '100%',
                height: 600,
            }
        },
        dialogUrl: './ckeditor/widgetEditorDialog.html'
    }
};
ckeditorConfig.toolbarCanCollapse ='true';
ckeditorConfig.toolbarStartupExpanded = false;
ckeditorConfig.pasteFromWordRemoveFontStyles = false;
ckeditorConfig.pasteFromWordRemoveStyles = false;

ckeditorConfig.basicEntities = false;
ckeditorConfig.entities_greek = false;
ckeditorConfig.entities_latin = false;
ckeditorConfig.entities_additional = '';

ckeditorConfig.filebrowserBrowseUrl= 'https://ckeditor.com/apps/ckfinder/3.4.5/ckfinder.html',
ckeditorConfig.filebrowserImageBrowseUrl= 'https://ckeditor.com/apps/ckfinder/3.4.5/ckfinder.html?type=Images',

ckeditorConfig.removeButtons = 'Underline,Subscript,Superscript,ShowBlocks,PageBreak,Save,NewPage,DocProps,Print,CreateDiv,Source';
ckeditorConfig.removePlugins = 'flash,iframe,ShowBlocks';
module.exports.ckeditorConfig = ckeditorConfig;